import React from "react";
import { Grid, Hidden } from "@material-ui/core";
import {
  Layout,
  Container,
  Curve,
  MainSection,
  DarkSection,
  Image
} from "components";
import ShopOurDevices from "sections/Home/ShopOurDevices";
import PlanSection from "sections/Home/PlanSection";
import InfoSection from "sections/Home/InfoSection";
import content from "_constants/content.json";

import "./styles.sass";

function Home(layoutProps: any): React.ReactElement {
  const storeBadges = (isMobile: boolean) => {
    return (
      <Grid
        item
        container
        alignItems={isMobile?"center":"flex-start"}
        justify={isMobile?"center":"flex-start"}
        spacing={2}
        className={"store"}
      >
        <Grid item>
          <a
            href={content.store.appStore}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image
              src="/images/badges/badge-appstore.png"
              className="badge"
              alt="App Store"
            />
          </a>
        </Grid>
        <Grid item>
          <a
            href={content.store.googlePlay}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image
              src="/images/badges/badge-googleplay.png"
              className="badge"
              alt="Google Play"
            />
          </a>
        </Grid>
      </Grid>
    )
  }
  return (
    <Layout className="home-section" {...layoutProps}>
      <Hidden smUp>
        <MainSection
          title={
            <span className="weight-800">
              What mobile
              <span className="text-sub weight-800"> can be.</span>
            </span>
          }
          text={
            <span className="text-center">
              Mobi is still in beta testing right now. Can’t wait?
              <br />
              <br />
              Just download the Mobi app to order your SIM card and start your activation!
            </span>
          }
        >
          <Container>
            {/* <JoinLaunchForm /> */}
            {storeBadges(true)}
          </Container>
          <div className="launch-image">
            <Image src="/images/img-home-mobile.png" alt="" />
          </div>
        </MainSection>
      </Hidden>

      <Hidden only="xs">
        <div className="launch-section">
          <Container className="launch-section-container">
            <Grid container justify="space-between">
              <Grid item sm={8}>
                <h1 className="launch-title">
                  <br className="text-mobile-width-breakpoint weight-800" /> What mobile
                  <span className="text-sub weight-800"> can be.</span>
                </h1>
                <p className="launch-sub-text text-left">
                  Mobi is still in beta testing right now. Can’t wait?
                  <br />
                  <br />
                  Just download the Mobi app and order your SIM card.
                  <br />
                  We’ll reach out as soon as a beta spot is ready for you.
                </p>
                {/* <JoinLaunchForm /> */}
                {storeBadges(false)}
              </Grid>
              <Grid item xs={12} md={5}>
                <div className="launch-section-image">
                  <Image src="/images/img-home.png" alt="launch" />
                </div>
              </Grid>
            </Grid>
          </Container>
        </div>
      </Hidden>

      <DarkSection>
        <PlanSection />
      </DarkSection>

      <Hidden smUp>
        <Curve reverse={true} />
      </Hidden>

      <InfoSection />

      <ShopOurDevices />
    </Layout>
  );
}

export default Home;
